import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'crg-choose-list-modal',
  templateUrl: './choose-list-modal.component.html'
})
export class ChooseListModalComponent implements OnInit {

  @ViewChild('selectButton') selectElem: ElementRef;
  @Input() buttonText?: string;
  @Input() buttonClass?: string;
  @Input() buttonIcon?: string;
  @Input() listItems: any[];
  @Input() listLabel: string;
  @Output() acceptClicked = new EventEmitter<string>();

  selectedItem: any = null;


  constructor() {
  }

  ngOnInit() {
    // this.acceptClicked.subscribe((value) => console.log('Emitted: ' + JSON.stringify(value)));
  }

  // openLg(content) {
  //   this.selectedItem = null;
  //   this.modal = this.modalService.open(content, { size: 'lg' });
  //   this.modal.result.then((result) => {
  //     this.closeResult = `Closed with: ${result}`;
  //     this.acceptClicked.emit('this.selectedItem');
  //   }, (reason) => {
  //     this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  //   });
  // }

  close(alert: any) {
    // this.alert = null;
  }

  // private getDismissReason(reason: any): string {
  //   if (reason === ModalDismissReasons.ESC) {
  //     return 'by pressing ESC';
  //   } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
  //     return 'by clicking on a backdrop';
  //   } else {
  //     return  `with: ${reason}`;
  //   }
  // }

  okClicked() {
    console.log('OK Clicked: ' + this.selectElem.nativeElement.value);
    this.acceptClicked.emit(this.selectElem.nativeElement.value);
  }
}
